const mixin = {
    props: {
        index: {
            type: Number,
            required: true,
        }
    },
    computed: {
        rowClass: function () {
            return this.index % 2 === 0 ? "even" : "odd"
        }
    }
}

export default mixin;